import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-250b51f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tutorial-container" }
const _hoisted_2 = {
  key: 0,
  class: "usage-guide-wrapper",
  ref: "scrollContainerRef"
}
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.guideInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            innerHTML: $setup.DOMPurify.sanitize($props.guideInfo?.content ?? '')
          }, null, 8 /* PROPS */, _hoisted_3),
          ($setup.scrollContainerRef)
            ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
                key: 0,
                container: $setup.scrollContainerRef
              }, null, 8 /* PROPS */, ["container"]))
            : _createCommentVNode("v-if", true)
        ], 512 /* NEED_PATCH */))
      : (_openBlock(), _createBlock($setup["EmptyContent"], {
          key: 1,
          text: "이용안내가 없습니다"
        }))
  ]))
}